import { SCREEN_SM } from '@/shared/constants/common';

const DESKTOP_HEADER_SCROLL_OFFSET = 176; // top bar (96px) + navigation island (80px)
const MOBILE_HEADER_SCROLL_OFFSET = 64;

const getFixedHeaderOffset = () => {
  const header = document.querySelector('header');

  if (!header) {
    return 0;
  }

  if (window.innerWidth <= SCREEN_SM) {
    return MOBILE_HEADER_SCROLL_OFFSET;
  }

  return DESKTOP_HEADER_SCROLL_OFFSET;
};

export const scrollToElementById = (
  targetId: string,
  options: ScrollToOptions = {},
) => {
  const targetElement = document.getElementById(targetId);

  if (!targetElement) {
    return;
  }

  const targetTop =
    targetElement.getBoundingClientRect().top +
    window.scrollY -
    getFixedHeaderOffset();

  window.scrollTo({
    top: Math.max(targetTop, 0),
    behavior: options.behavior,
  });
};

const smoothScroll = (
  targetId: string,
  targetPosition: ScrollLogicalPosition = 'start',
) => {
  if (targetPosition !== 'start') {
    const targetElement = document.getElementById(targetId);

    targetElement?.scrollIntoView({
      behavior: 'smooth',
      block: targetPosition,
    });

    return;
  }

  scrollToElementById(targetId, { behavior: 'smooth' });
};

export default smoothScroll;
